import { useMutation } from '@tanstack/react-query'
import { updateHelp } from '../index'

const useUpdateHelp = () =>
  useMutation({
    mutationFn: updateHelp,
  })

export default useUpdateHelp
